module.exports = __webpack_public_path__ + "media/images/homelight-2025-ae4d89b05fe382bce1677743f73a09a6.png";